import React from 'react';
import { NavLink } from 'react-router-dom';
export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query:"",
      dataHolder: props.dataHolder,
    };
  }
  T(record, recordType) {
    if (record == null || record == undefined) return '';
    var lang = this.state.dataHolder.lang;
    var output = '';
    if (recordType === 'real_person_name') {
      if (lang === 'fa') output = record.fname + ' ' + record.lname;
      if (lang !== 'fa') output = record.fname_en + ' ' + record.lname_en;
      if (lang !== 'fa' && (output.trim()) == '') output = record.fname + ' ' + record.lname;
    }
   
    return output;
  }
  money(value) {
    if (value == null || value == undefined) return "";    
    var number = typeof value === 'number' ? value.toString() : value;
    number = number.replace(/\./g,'/');
    
    var separator = ',';
    if (number === null || number === undefined) return '';
    var s = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + separator);
    return s;
  }
  componentDidMount(){
    if (typeof window !== 'undefined') {
      if (document != undefined && document != null) {
        if (localStorage.theme === 'dark') {
          document.documentElement.classList.add('dark');
          localStorage.theme = 'dark';
        } else {
          document.documentElement.classList.remove('dark');
          localStorage.removeItem('theme');
        }
      }
    }
  }
  DarkToggle() {
    if (typeof window !== 'undefined') {
      if (document != null && document != undefined) {
        if (localStorage.theme === 'dark') {
          document.documentElement.classList.remove('dark');
          localStorage.removeItem('theme');
        } else {
          document.documentElement.classList.add('dark');
          localStorage.theme = 'dark';
        }
      }
    }
  }
  MenuToggle() {
    if (typeof window !== 'undefined') {
      document.getElementById('mobile-menu').classList.toggle('hidden');
      document.getElementById('mobile-menu').classList.toggle('flex');
      document.getElementById('mobile-menu').classList.toggle('bottom-0');
      document.getElementById('mobile-menu').classList.toggle('top-0');
    }
  }
  search(e){
    e.preventDefault();    
    if (this.state.query != '' && this.state.query != undefined && this.state.query != null) 
      window.location.href = "/search/paper/t-" + this.state.query + "/";
    else
      window.location.href = "/search/paper/";
  }
  getRealPersonId(realPerson) {
    if (realPerson == null || realPerson == undefined) return null;
    if (realPerson.person_id < 170000) return realPerson.old_id_in_civilica;
    else return realPerson.person_id;
  }  
  httpPost(apiUrl, body = {}) {
    return new Promise((resolve, reject) => {
      fetch(apiUrl, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((dataHolder) => {
        resolve(dataHolder);
      })
      .catch((e) => { 
        reject(null);
      });
    });
  }
  logOut(e)
  {
    this.httpPost("/ajax/logout/")
    .then(resp=>{
      if(resp.status === 1 ){
        if (typeof window === "undefined") return;
        window.location.href = "/login/";
      }
      else{
      }
    })
    .catch(err=>{
    });
  }
  setQuery(e){
    this.state.query = e.target.value;
  }
  showChangeLanguage(){
    var v = true;
    try{
      var link = window.location.href.toLowerCase();
      if (link.includes("/download/")) v = false;
      if (link.includes("/certificate/")) v = false;
    }
    catch{}
    return v;
  }
  render() {
    if (typeof window !== 'undefined') {
      if (document != undefined && document != null) {
        try {
          let position = window.scrollY;

          document.addEventListener('scroll', () => {
            let scroll = window.scrollY;
            var element = document.getElementById('header');
            if (element) {
              if (position > scroll && scroll > 60) {
                element.classList.add('header-fixed');
                element.classList.remove('lg:relative');
              } else {
                element.classList.remove('header-fixed');
                element.classList.add('lg:relative');
              }
            }
            position = scroll;
          });
        } catch (err) {}
      }
    }

    return <header>
              <div className="bg-brand dark:bg-light-700 px-4 pt-3 lg:py-0 flex flex-col lg:flex-row items-center justify-between  text-white" style={{"border-bottom": "solid #f9b931"}}>
                <div className="flex items-center justify-between w-full lg:w-auto mb-4 dark:bg-light-700 lg:mb-0 fixed top-0 h-12 bg-brand p-4 lg:p-0 lg:relative lg:h-auto z-99">
                  <button aria-label="منو" onClick={this.MenuToggle.bind(this)}>
                    <svg className=" h-5 w-5 sm:h-6 sm:w-6 text-white fill-current lg:hidden" viewBox="0 0 448 512">
                      <path d="M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z"/>
                    </svg>
                  </button>
                  <NavLink to="/" className="flex dark:bg-light-700 items-center hidden md:block" title={this.state.dataHolder.lang === "en" ? "Home" : 'صفحه اصلی'}>
                    <div alt={this.state.dataHolder.lang === "en" ? "Civilica" : "سیویلیکا"} style={{"margin-top": "20px","width": "275px","height": "70px","backgroundImage": "url('/assets/img/logo.png')","backgroundSize": "contain","backgroundRepeat": "no-repeat"}}></div>
                  </NavLink>
                  <NavLink to="/" className="flex dark:bg-light-700 items-center md:hidden" title={this.state.dataHolder.lang === "en" ? "Home" : 'صفحه اصلی'}>
                    <div title={this.state.dataHolder.lang === "en" ? "Civilica" : 'سیویلیکا'} style={{"backgroundImage": "url('/assets/images/logo_m.webp')"}} className="w-28 logoM" />
                  </NavLink>
                  <div className="flex space-x-4 rtl:space-x-reverse lg:hidden">
                    {this.state.dataHolder.currentPerson !== null && this.state.dataHolder.currentPerson !== undefined ? 
                      <NavLink to="/profile/" className={"flex flex-wrap"}>
                        {this.state.dataHolder.currentPerson.pic == '' || this.state.dataHolder.currentPerson.pic == null ?
                          <svg className=" h-5 w-5 sm:h-6 sm:w-6 text-white fill-current" viewBox="0 0 448 512">
                            <path d="M272 304h-96C78.8 304 0 382.8 0 480c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32C448 382.8 369.2 304 272 304zM48.99 464C56.89 400.9 110.8 352 176 352h96c65.16 0 119.1 48.95 127 112H48.99zM224 256c70.69 0 128-57.31 128-128c0-70.69-57.31-128-128-128S96 57.31 96 128C96 198.7 153.3 256 224 256zM224 48c44.11 0 80 35.89 80 80c0 44.11-35.89 80-80 80S144 172.1 144 128C144 83.89 179.9 48 224 48z"/>
                          </svg>
                        :
                          <img className="h-8 w-8 rounded-full mx-2" src={"/media/r/" + this.state.dataHolder.currentPerson.pic} />
                        }
                        <small className={"text-white text-center"}> {this.T(this.state.dataHolder.currentPerson,"real_person_name")}<br/>{this.money(this.state.dataHolder.currentPerson.credit)} {this.state.dataHolder.lang === "en" ? "Credit" : "اعتبار"}</small>
                      </NavLink>
                    : 
                      <NavLink to="/login/" className={"flex flex-wrap"}>
                        <svg className=" h-5 w-5 sm:h-6 sm:w-6 text-white fill-current" viewBox="0 0 640 512">
                          <path d="M576 288V208c0-44.11-35.87-80-79.1-80S416 163.9 416 208V288c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h160c35.35 0 64-28.65 64-64v-96C640 316.7 611.3 288 576 288zM448 208C448 181.5 469.5 160 496 160S544 181.5 544 208V288h-96V208zM608 448c0 17.64-14.36 32-32 32h-160c-17.64 0-32-14.36-32-32v-96c0-17.64 14.36-32 32-32h160c17.64 0 32 14.36 32 32V448zM496 376c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24C520 386.7 509.3 376 496 376zM224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM173.3 336H274.7c9.516 0 18.76 1.062 27.71 2.971c10.27 2.191 19.9-6.207 18.1-16.67c-.0098-.1172-.0195-.2363-.0313-.3555c-.6172-7.242-5.881-13.08-13.01-14.52C297.4 305.2 286.2 304 274.7 304H173.3C77.54 304-.1152 381.6 0 477.4C.0234 496.4 15.63 512 34.66 512H304c8.836 0 16-7.164 16-16c0-8.838-7.164-16-16-16H34.66C33.21 480 32 478.8 32 477.3C31.99 399.4 95.4 336 173.3 336z"/>  
                        </svg><span className={"text-white"}> {this.state.dataHolder.lang === "en" ? "Login" : "ورود"}</span>
                      </NavLink>
                    }
                  </div>
                </div>
                  <form method="post" onSubmit={e=>this.search(e)} className="lg:w-[450px] w-full relative mt-10 lg:mt-0">
                    <input
                      type="search"
                      style={{"border-radius": "20px"}}
                      onChange={e=>this.setQuery(e)}
                      placeholder={this.state.dataHolder.lang === "en" ? "Search in "  + new Intl.NumberFormat().format(this.state.dataHolder.globalValues.document_counts) +  " documents" : 'جستجو در ' + new Intl.NumberFormat().format(this.state.dataHolder.globalValues.document_counts) + ' مقاله و مستندعلمی '}
                      className="rounded w-full text-color-base text-xs sm:text-sm dark:bg-light-600 dark:border-light-800"
                    />
                    <button aria-label={this.state.dataHolder.lang === "en" ? "Search" : "جستجو"} type='submit' className={'w-6 h-6 absolute top-1 ' + (this.state.dataHolder.lang === "en" ? "right-0" : "left-0") + ' text-gray-700'} style={{"color": "#f9b931","margin-left": (this.state.dataHolder.lang === "en" ? "0px" : "10px"),"margin-right": (this.state.dataHolder.lang === "en" ? "10px" : "0px"),"margin-top": "3px"}}>
                      <svg className="h-5 w-5 sm:h-6 sm:w-6 fill-current" viewBox="0 0 512 512">
                        <path d="M507.3 484.7l-141.5-141.5C397 306.8 415.1 259.7 415.1 208c0-114.9-93.13-208-208-208S-.0002 93.13-.0002 208S93.12 416 207.1 416c51.68 0 98.85-18.96 135.2-50.15l141.5 141.5C487.8 510.4 491.9 512 496 512s8.188-1.562 11.31-4.688C513.6 501.1 513.6 490.9 507.3 484.7zM208 384C110.1 384 32 305 32 208S110.1 32 208 32S384 110.1 384 208S305 384 208 384z"/>
                      </svg>
                    </button>
                  </form>
                  <div className="flex hidden lg:block">
                    <NavLink to="/search/paper/" className="px-2 py-3  hover:bg-white/20 inline-block" title={this.state.dataHolder.lang === "en" ? "Advanced search" : 'جستجوی مقالات کنفرانسها و ژورنالها'}>{this.state.dataHolder.lang === "en" ? "Advanced search" : "جستجوی پیشرفته"}</NavLink>
                    <NavLink to="/thesis/" className="px-2 py-3  hover:bg-white/20 inline-block" title={this.state.dataHolder.lang === "en" ? "Thesis" : 'استعلام پایان نامه'}>{this.state.dataHolder.lang === "en" ? "Thesis" : "استعلام پایان نامه"}</NavLink>
                  </div>
                <div className="lg:hidden text-white flex flex-wrap">
                  <NavLink to='/search/paper/' title={this.state.dataHolder.lang === "en" ? "Papers" : 'مقاله فارسی'} className="py-3 px-2">{this.state.dataHolder.lang === "en" ? "Papers" : "مقاله فارسی"}</NavLink>
                  {this.state.dataHolder.lang === "fa" && <NavLink to='/search/isi/' title='ISI' className="py-3 px-2">ISI</NavLink>}
                  <NavLink to='/calendar/' title={this.state.dataHolder.lang === "en" ? "Conferences" : 'کنفرانس ها'} className="py-3 px-2">{this.state.dataHolder.lang === "en" ? "Conferences" : "کنفرانسها"}</NavLink>
                  <NavLink to='/journals/' title={this.state.dataHolder.lang === "en" ? "Journals" : 'ژورنال ها'} className="py-3 px-2">{this.state.dataHolder.lang === "en" ? "Journals" : "ژورنالها"}</NavLink>
              </div>
              </div>
              <div id="bg-menu" className="fixed inset-0 bg-slate-400/40 hidden z-10" onClick={this.MenuToggle.bind(this)}></div>
              <div
                id="header"
                className="lg:flex flex-col-reverse justify-end  fixed rtl:right-0 ltr:left-0 bottom-0 hidden lg:bottom-auto w-80 rtl:-mr-80 ltr:-ml-80 lg:rtl:mx-0 lg:ltr:mx-0 lg:w-auto z-999  lg:flex-row lg:items-center py-3 lg:py-0  lg:justify-between  px-4 border-y border-gray-200 dark:border-light-600 bg-gray-100 dark:bg-light-600 lg:relative top-0"
              >
                <button aria-label="منو" onClick={this.MenuToggle.bind(this)} className=" lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className=" h-8 w-8 bg-gray-500 dark:bg-light-700 rounded-full p-1 text-white fill-current lg:hidden absolute top-3 rtl:left-3 ltr:right-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                <ul className="flex flex-col lg:flex-row lg:items-center lg:space-x-2 rtl:space-x-reverse font-medium ">
                  <li>
                    <NavLink to="/search/paper/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Search" : 'جستجوی و دانلود مقاله'}>{this.state.dataHolder.lang === "en" ? "Papers" : "مقاله"}</NavLink>
                  </li>
                  {this.state.dataHolder.lang === "fa" && <li>
                    <NavLink
                      to="/search/isi/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "ISI" : 'جستجوی مقاله از منابع بین المللی انگلیسی'}
                    >{this.state.dataHolder.lang === "en" ? "ISI" : "مقاله ISI"}</NavLink>
                  </li>}
                  <li>
                    <NavLink to="/calendar/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Conferences" : 'کنفرانسها و همایشهای علمی کشور'}>{this.state.dataHolder.lang === "en" ? "Conferences" : "کنفرانس های ایران"}</NavLink>
                  </li>
                  <li>
                    <NavLink to="/journals/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Journals" : 'ژورنالها و مجلات تخصصی'}>{this.state.dataHolder.lang === "en" ? "Journals" : "ژورنالها و مجلات"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/conferences/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Papers" : 'لیست کامل کنفرانسهای کشور'}
                    >{this.state.dataHolder.lang === "en" ? "Papers" : "مجموعه مقالات"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/meetings/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Meetings" : 'اطلاع رسانی کلیه جلسات علمی و تخصصی کشور'}
                    >{this.state.dataHolder.lang === "en" ? "Meetings" : "جلسات علمی"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/notes/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Notes" : 'یادداشت های علمی'}
                    >{this.state.dataHolder.lang === "en" ? "Notes" : "یادداشت های علمی"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/preprints/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Preprints" : 'مخزن پیش چاپ'}
                    >{this.state.dataHolder.lang === "en" ? "Preprints" : "مخزن پیش چاپ"}</NavLink>
                  </li>
                </ul>
                <div className="flex lg:justify-center items-center font-medium mt-4 lg:mt-0 border-b dark:border-light-700 ">
                  {this.showChangeLanguage() ?
                    this.state.dataHolder.lang === 'fa' ?
                      <a href={(this.state.dataHolder.metaTags.canonical != null && this.state.dataHolder.metaTags.canonical != undefined ) ? this.state.dataHolder.metaTags.canonical.replace("https://", "https://en.") : "https://en.civilica.caom"} hrefLang="en" title='English'>English</a>
                    :
                      <a href={(this.state.dataHolder.metaTags.canonical != null && this.state.dataHolder.metaTags.canonical != undefined ) ? this.state.dataHolder.metaTags.canonical.replace("https://en.", "https://") : "https:/civilica.com"} hrefLang="fa-ir" title='فارسی'>فارسی</a>
                  :null}
                  <button aria-label="حالت تیره"
                    type="button"
                    id="btn_mode1"
                    onClick={this.DarkToggle.bind(this)}
                    className="bg-gray-200 mx-2 dark:bg-light-700 relative sm:inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none "
                  >
                    <span className="translate-x-0  pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200">
                      <span className="opacity-100 ease-in duration-200 dark:opacity-0 dark:ease-out dark:duration-100 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
                        <svg className=" h-4 w-4 text-yellow-500" viewBox="0 0 512 512">
                          <path d="M256 112C247.2 112 240 104.8 240 96V16C240 7.156 247.2 0 256 0s16 7.156 16 16V96C272 104.8 264.8 112 256 112zM272 496V416c0-8.844-7.156-16-16-16S240 407.2 240 416v80c0 8.844 7.156 16 16 16S272 504.8 272 496zM512 256c0-8.844-7.156-16-16-16H416c-8.844 0-16 7.156-16 16s7.156 16 16 16h80C504.8 272 512 264.8 512 256zM112 256c0-8.844-7.156-16-16-16H16C7.156 240 0 247.2 0 256s7.156 16 16 16H96C104.8 272 112 264.8 112 256zM380.5 154.2l56.56-56.59c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0l-56.56 56.59c-6.25 6.25-6.25 16.37 0 22.62c3.125 3.125 7.219 4.691 11.31 4.691S377.3 157.3 380.5 154.2zM97.61 437l56.56-56.59c6.25-6.25 6.25-16.37 0-22.62s-16.38-6.253-22.62-.0031l-56.56 56.59c-6.25 6.25-6.25 16.38 0 22.62c3.125 3.125 7.219 4.688 11.31 4.688S94.48 440.2 97.61 437zM437 437c6.25-6.25 6.25-16.38 0-22.62l-56.56-56.59c-6.25-6.25-16.38-6.247-22.62 .0031s-6.25 16.37 0 22.62l56.56 56.59c3.125 3.125 7.219 4.688 11.31 4.688S433.9 440.2 437 437zM154.2 154.2c6.25-6.25 6.25-16.37 0-22.62L97.61 74.97c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l56.56 56.59c3.125 3.125 7.219 4.688 11.31 4.688S151 157.3 154.2 154.2zM368 256c0-61.75-50.25-112-112-112S144 194.3 144 256s50.25 112 112 112S368 317.8 368 256zM336 256c0 44.13-35.89 80-80 80S176 300.1 176 256S211.9 176 256 176S336 211.9 336 256z" fill="currentColor"/>
                        </svg>
                      </span>
                      <span className="opacity-0 ease-out duration-100 dark:opacity-100 dark:ease-in dark:duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
                        <svg className=" h-4 w-4 text-yellow-800" viewBox="0 0 512 512">
                          <path d="M428.3 367.5c-5.609-9.312-16.08-13.91-26.75-11.97c-42.39 8.188-85.83-2.938-119.2-30.5C248.4 297 228.9 255.5 228.9 211.3c0-52.75 28.2-101.8 73.59-127.8c9.453-5.406 14.38-15.88 12.55-26.66c-1.812-10.75-9.891-19-20.61-21C283.1 33.66 265.3 32 253.9 32C131.5 32 32 132.5 32 256s99.55 224 221.9 224c67.19 0 130-30.25 172.4-83C433.1 388.4 433.9 376.9 428.3 367.5zM253.9 448C149.2 448 64 361.9 64 256s85.19-192 189.9-192c4.891 0 11.53 .4062 18.09 1.031C225.3 98.34 196.9 152.9 196.9 211.3c0 53.84 23.7 104.3 65.05 138.5c36.25 29.94 82.17 43.88 128.5 39.69C354.8 426.8 305.8 448 253.9 448z" fill="currentColor"/>
                        </svg>
                      </span>
                    </span>
                  </button>
                  {this.state.dataHolder.currentPerson !== null && this.state.dataHolder.currentPerson !== undefined ?
                    <NavLink to="/profile" className="flex my-1 relative profileMenuHolder">
                      {this.state.dataHolder.notifications != null ?
                        this.state.dataHolder.notifications.totalNotification > 0 &&
                        <span className='notificationBatch absolute' style={this.state.dataHolder.lang === 'en' ? {"left": "0","right": "unset"} : {}}>{this.state.dataHolder.notifications.totalNotification}</span>
                      :null}
                      {this.state.dataHolder.currentPerson.pic ?
                        <img src={'https://civilica.com/media/r/' + this.state.dataHolder.currentPerson.pic} alt={this.T(this.state.dataHolder.currentPerson,"real_person_name")} className="mx-auto w-10 rounded-full rtl:ml-1 ltr:mr-1"></img>
                      :
                        <img src="/assets/images/no-pic.gif" alt={this.T(this.state.dataHolder.currentPerson,"real_person_name")} className="mx-auto w-10 rounded-full rtl:ml-1 ltr:mr-1"></img>
                      }
                      <span className="flex flex-col space-y-1">
                        <span>
                          {this.T(this.state.dataHolder.currentPerson,"real_person_name")}
                        </span>
                        <span className="text-xs text-green-700">
                        {this.state.dataHolder.lang === "en" ? "Credit" : "اعتبار"}:
                          {this.money(this.state.dataHolder.currentPerson.credit)}
                        </span>
                      </span>

                      <ul className='profileMenu border shadow-me rounded hidden' style={this.state.dataHolder.lang === 'en' ? {"right": "0"} : {}}>
                        <li>
                          <NavLink
                            to="/profile/"
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            {this.state.dataHolder.lang === "en" ? "Profile" : "اطلاعات حساب کاربری"}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={'/p/' + this.getRealPersonId(this.state.dataHolder.currentPerson) + '/edit/'}
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            رزومه علمی
                            {this.state.dataHolder.notifications != null ?
                              this.state.dataHolder.notifications.suggestion > 0 &&
                              <span className='notificationBatch rtl:mr-2 ltr:ml-2'>{this.state.dataHolder.notifications.suggestion}</span>
                            :null}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/profile/financial/"
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            افزایش اعتبار
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/profile/favorites/"
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            {this.state.dataHolder.lang === "en" ? "My favorites" : "علاقه مندی ها"}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/profile/support/"
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            {this.state.dataHolder.lang === "en" ? "Support" : "پشتیبانی / پیام ها"}
                            {this.state.dataHolder.notifications != null ?
                              this.state.dataHolder.notifications.newMessage > 0 &&
                              <span className='notificationBatch rtl:mr-2 ltr:ml-2'>{this.state.dataHolder.notifications.newMessage}</span>
                            :null}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/profile/certificate/"
                            className={({ isActive }) =>
                              isActive ? 'border-r-2 border-brand bg-indigo-50 text-brand dark:bg-light-600 px-2 py-3 flex' : 'hover:bg-indigo-50 dark:hover:bg-light-600 hover:text-brand px-2 py-3 flex '
                            }
                          >
                            {this.state.dataHolder.lang === "en" ? "Cerificate" : "گواهینامه"}
                            {this.state.dataHolder.notifications != null ?
                              this.state.dataHolder.notifications.certificate > 0 &&
                              <span className='notificationBatch rtl:mr-2 ltr:ml-2'>{this.state.dataHolder.notifications.certificate}</span>
                            :null}
                          </NavLink>
                        </li>
                        <li>
                          <a
                            href='#'
                            className='hover:bg-red-50 dark:hover:bg-light-600 text-red-500 px-2 py-3 flex'
                            onClick={e=>this.logOut(e)}
                          >
                            {this.state.dataHolder.lang === "en" ? "Logout" : "خروج"}
                          </a>
                        </li>
                      </ul>
                    </NavLink>
                  :
                    <NavLink to="/login/" className="px-4 py-1 rounded bg-red-600 hover:bg-red-600 text-white">{this.state.dataHolder.lang === "en" ? "Login/Register" : "ورود / ثبت نام"}</NavLink>
                  }
                </div>
              </div>
              <div id='mobile-menu' className='fixed inset-x-0 inset-y-0  transform transition-all duration-500 ease-in-out bg-white dark:bg-light-600 z-999 hidden flex-col justify-between  lg:hidden'>
                <header className='flex items-center justify-between p-4 border-b border-gray-300 dark:border-light-700'>
                <button aria-label="منو" onClick={this.MenuToggle.bind(this)} className=" lg:hidden">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className=" h-8 w-8 bg-gray-200 dark:bg-light-700 rounded p-1 text-gray-500 fill-current "
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                </header>

                <ul className="flex flex-col mb-auto divide-y divide-gray-300 dark:divide-light-700 font-medium border-b border-gray-300 dark:border-light-700">
                  <li>
                    <NavLink to="/search/paper/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Search" : 'جستجوی و دانلود مقاله'}>{this.state.dataHolder.lang === "en" ? "Papers" : "مقاله"}</NavLink>
                  </li>
                  {this.state.dataHolder.lang === "fa" && <li>
                    <NavLink
                      to="/search/isi/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "ISI" : 'جستجوی مقاله از منابع بین المللی انگلیسی'}
                    >{this.state.dataHolder.lang === "en" ? "ISI" : "مقاله ISI"}</NavLink>
                  </li>}
                  <li>
                    <NavLink to="/calendar/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Conferences" : 'کنفرانسها و همایشهای علمی کشور'}>{this.state.dataHolder.lang === "en" ? "Conferences" : "کنفرانس های ایران"}</NavLink>
                  </li>
                  <li>
                    <NavLink to="/journals/" className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand" title={this.state.dataHolder.lang === "en" ? "Journals" : 'ژورنالها و مجلات تخصصی'}>{this.state.dataHolder.lang === "en" ? "Journals" : "ژورنالها و مجلات"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/conferences/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Papers" : 'لیست کامل کنفرانسهای کشور'}
                    >{this.state.dataHolder.lang === "en" ? "Papers" : "مجموعه مقالات"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/meetings/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={this.state.dataHolder.lang === "en" ? "Meetings" : 'اطلاع رسانی کلیه جلسات علمی و تخصصی کشور'}
                    >{this.state.dataHolder.lang === "en" ? "Meetings" : "جلسات علمی"}</NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/thesis/"
                      className="px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand"
                      title={'استعلام پایان نامه'}
                    >استعلام پایان نامه</NavLink>
                  </li>
                  <li className='flex items-center justify-between '>
                    {this.showChangeLanguage() ?
                      this.state.dataHolder.lang === 'fa' ?
                        <a className='px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand' href={(this.state.dataHolder.metaTags.canonical != null && this.state.dataHolder.metaTags.canonical != undefined ) ? this.state.dataHolder.metaTags.canonical.replace("https://", "https://en.") : "https://en.civilica.caom"} hrefLang="en" title='English'>English</a>
                      :
                        <a className='px-2 py-3 hover:bg-brand/10 inline-block hover:text-brand' href={(this.state.dataHolder.metaTags.canonical != null && this.state.dataHolder.metaTags.canonical != undefined ) ? this.state.dataHolder.metaTags.canonical.replace("https://en.", "https://") : "https:/civilica.com"} hrefLang="fa-ir" title='فارسی'>فارسی</a>
                    :null}
                    <button aria-label="حالت تیره"
                      type="button"
                      id="btn_mode2"
                      onClick={this.DarkToggle.bind(this)}
                      className="bg-gray-200   mx-5  dark:bg-light-700 relative sm:inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none "
                    >
                      <span className="translate-x-0  pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200">
                        <span className="opacity-100 ease-in duration-200 dark:opacity-0 dark:ease-out dark:duration-100 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
                          <svg className=" h-4 w-4 text-yellow-500" viewBox="0 0 512 512">
                            <path d="M256 112C247.2 112 240 104.8 240 96V16C240 7.156 247.2 0 256 0s16 7.156 16 16V96C272 104.8 264.8 112 256 112zM272 496V416c0-8.844-7.156-16-16-16S240 407.2 240 416v80c0 8.844 7.156 16 16 16S272 504.8 272 496zM512 256c0-8.844-7.156-16-16-16H416c-8.844 0-16 7.156-16 16s7.156 16 16 16h80C504.8 272 512 264.8 512 256zM112 256c0-8.844-7.156-16-16-16H16C7.156 240 0 247.2 0 256s7.156 16 16 16H96C104.8 272 112 264.8 112 256zM380.5 154.2l56.56-56.59c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0l-56.56 56.59c-6.25 6.25-6.25 16.37 0 22.62c3.125 3.125 7.219 4.691 11.31 4.691S377.3 157.3 380.5 154.2zM97.61 437l56.56-56.59c6.25-6.25 6.25-16.37 0-22.62s-16.38-6.253-22.62-.0031l-56.56 56.59c-6.25 6.25-6.25 16.38 0 22.62c3.125 3.125 7.219 4.688 11.31 4.688S94.48 440.2 97.61 437zM437 437c6.25-6.25 6.25-16.38 0-22.62l-56.56-56.59c-6.25-6.25-16.38-6.247-22.62 .0031s-6.25 16.37 0 22.62l56.56 56.59c3.125 3.125 7.219 4.688 11.31 4.688S433.9 440.2 437 437zM154.2 154.2c6.25-6.25 6.25-16.37 0-22.62L97.61 74.97c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l56.56 56.59c3.125 3.125 7.219 4.688 11.31 4.688S151 157.3 154.2 154.2zM368 256c0-61.75-50.25-112-112-112S144 194.3 144 256s50.25 112 112 112S368 317.8 368 256zM336 256c0 44.13-35.89 80-80 80S176 300.1 176 256S211.9 176 256 176S336 211.9 336 256z" fill="currentColor"/>
                          </svg>
                        </span>
                        <span className="opacity-0 ease-out duration-100 dark:opacity-100 dark:ease-in dark:duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity">
                          <svg className=" h-4 w-4 text-yellow-800" viewBox="0 0 512 512">
                            <path d="M428.3 367.5c-5.609-9.312-16.08-13.91-26.75-11.97c-42.39 8.188-85.83-2.938-119.2-30.5C248.4 297 228.9 255.5 228.9 211.3c0-52.75 28.2-101.8 73.59-127.8c9.453-5.406 14.38-15.88 12.55-26.66c-1.812-10.75-9.891-19-20.61-21C283.1 33.66 265.3 32 253.9 32C131.5 32 32 132.5 32 256s99.55 224 221.9 224c67.19 0 130-30.25 172.4-83C433.1 388.4 433.9 376.9 428.3 367.5zM253.9 448C149.2 448 64 361.9 64 256s85.19-192 189.9-192c4.891 0 11.53 .4062 18.09 1.031C225.3 98.34 196.9 152.9 196.9 211.3c0 53.84 23.7 104.3 65.05 138.5c36.25 29.94 82.17 43.88 128.5 39.69C354.8 426.8 305.8 448 253.9 448z" fill="currentColor"/>
                          </svg>
                        </span>
                      </span>
                    </button>
                  </li>
                </ul>
                <footer className='p-4 flex justify-start border-t border-gray-300 dark:border-light-700'>
                {this.state.dataHolder.currentPerson !== null && this.state.dataHolder.currentPerson !== undefined ?
                    <NavLink to="/profile" className="flex my-1 ">
                      {this.state.dataHolder.currentPerson.pic ?
                        <img src={'/media/r/' + this.state.dataHolder.currentPerson.pic} alt={this.T(this.state.dataHolder.currentPerson,"real_person_name")} className="mx-auto w-10 rounded-full rtl:ml-1 ltr:mr-1"></img>
                      :
                        <img src="/assets/images/no-pic.gif" alt={this.T(this.state.dataHolder.currentPerson,"real_person_name")} className="mx-auto w-10 rounded-full rtl:ml-1 ltr:mr-1"></img>
                      }
                      <span className="flex flex-col space-y-1">
                        <span>
                          {this.T(this.state.dataHolder.currentPerson,"real_person_name")}
                        </span>
                        <span className="text-xs text-green-700">
                        {this.state.dataHolder.lang === "en" ? "Credit" : "اعتبار"}:
                          {this.money(this.state.dataHolder.currentPerson.credit)}
                        </span>
                      </span>
                    </NavLink>
                  :
                    <NavLink to="/login/" className=" flex-auto flex items-center justify-around">
                      <span className='px-8 py-2'>{this.state.dataHolder.lang === "en" ? "Login" : "ورود"}</span>
                      <span className='px-8 py-2 rounded bg-red-500 hover:bg-red-600 text-white'>{this.state.dataHolder.lang === "en" ? "Register" : "ثبت نام"}</span>
                    </NavLink>
                    }
                </footer>
              </div>
            </header>
  }
}
